<template>
  <div>
    <div v-if="!showResults">
      <v-card
        flat
        class="pa-2 d-flex flex-row flex-wrap align-end"
        :loading="loading"
      >
        <div>
          <div class="text-h4">Advanced Search</div>
          <div class="caption">
            Search EyeDock's database by constructing a fancy query
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="searchItemPicker"
          max-width="400"
          scrollable
          v-if="!$vuetify.breakpoint.mdAndUp"
        >
          <template v-slot:activator="{ on, attrs }">
            <!-- <v-spacer></v-spacer> -->
            <v-btn v-bind="attrs" v-on="on" class="my-2" text>
              <v-icon color="green" class="mr-2">mdi-plus-circle</v-icon> Add
              Search Fields
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="d-flex flex-row orangeCardTitle">
              Add/Edit Search Fields
              <v-spacer></v-spacer>
              <v-btn @click="searchItemPicker = false" icon
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </v-card-title>
            <v-card-text class="d-flex flex-column">
              <cl-adv-search-fields
                :wantedItems="wantedItems"
                :formOptions="formOptions"
                @wantedItems="wantedItems = $event"
              ></cl-adv-search-fields>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card>
      <v-container>
        <v-row>
          <v-col cols="12" md="8">
            <!-- <div class="overline">Company</div> -->
            <div class="d-flex flex-row flex-wrap mt-4 align-center px-2 pb-2">
              <type-select
                class="my-2 mr-2"
                :external="type_tag"
                @type="
                  formValues.type_tag = $event;
                  type = $event;
                "
                @image="typeImage = $event"
              ></type-select>
              <v-fade-transition>
                <v-tooltip
                  bottom
                  max-width="250"
                  color="error"
                  v-if="typeMismatch.length"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small class="mr-6">
                      <v-icon small v-bind="attrs" v-on="on" color="error"
                        >mdi-alert</v-icon
                      ></v-btn
                    >
                  </template>
                  <span v-html="typeMismatchMessage.message"></span>
                </v-tooltip>
              </v-fade-transition>

              <replace-select
                class="my-2 mr-3"
                :external="replace"
                @replace="
                  formValues.replace = $event;
                  replace = $event;
                "
                @image="replaceImage = $event"
              ></replace-select>
              <!-- <v-spacer></v-spacer> -->
              <!-- <soft-company-picker class="mt-1 mr-3"></soft-company-picker> -->
              <!-- <select-company-picker :multiple="true"></select-company-picker> -->
            </div>

            <!-- {{ optionRows }} -->
            <div class="d-flex flex-row flex-wrap">
              <v-card
                v-for="(optionRow, index) in optionRows"
                :key="'optionRow' + index"
                :width="$vuetify.breakpoint.smAndUp ? 300 : '100%'"
                flat
                class="ma-2 pa-2 paramCard"
              >
                <div class="overline d-flex flex-row align-center">
                  <div style="width: 30px">
                    <v-icon
                      v-if="optionRow.icon"
                      small
                      color="primary"
                      class="mr-2"
                      >mdi-{{ optionRow.icon }}</v-icon
                    >

                    <v-img
                      v-else-if="optionRow.image"
                      :src="iconSrc + optionRow.image"
                      width="18"
                      class="mr-2 my-auto"
                      position="center center"
                    ></v-img>
                  </div>

                  {{ optionRow.name }}

                  <v-icon
                    v-if="optionRow.input == 'yes'"
                    color="green"
                    class="ml-2"
                    >mdi-check</v-icon
                  >

                  <v-spacer></v-spacer
                  ><v-btn icon small @click="wantedItems.splice(index, 1)"
                    ><v-icon small>mdi-close</v-icon></v-btn
                  >
                </div>
                <div class="ml-2" v-if="optionRow.input != 'yes'">
                  <!-- <div v-if="optionRow.value">yes</div> -->
                  <v-btn-toggle
                    v-if="optionRow.input == 'bool'"
                    rounded
                    v-model="formValues[optionRow.id]"
                    active-class="orangeActive"
                    class="toggleBtns mt-1"
                  >
                    <v-btn small :val="0">No</v-btn>
                    <v-btn small :val="1">Yes</v-btn>
                  </v-btn-toggle>
                  <div
                    v-else-if="optionRow.input == 'select'"
                    class="d-flex flex-row align-center"
                  >
                    <div
                      v-if="
                        optionRow.operator && optionRow.operator == 'moreless'
                      "
                      class="mr-2"
                    >
                      <v-btn-toggle
                        v-model="formValues['moreless_' + optionRow.id]"
                        rounded
                        active-class="orangeActive"
                        class="toggleBtns mt-1"
                      >
                        <v-btn small :value="-1">&lt;=</v-btn>
                        <v-btn small :value="1">&gt;=</v-btn>
                      </v-btn-toggle>
                    </div>
                    <div
                      v-if="optionRow.options && optionRow.options.length > 3"
                    >
                      <v-autocomplete
                        v-if="optionRow.multiple"
                        v-model="formValues[optionRow.id]"
                        :items="optionRow.options"
                        item-value="value"
                        item-text="label"
                        outlined
                        dense
                        auto-select-first
                        chips
                        small-chips
                        deletable-chips
                        multiple
                        hide-details
                        menu-props="auto"
                        class="whiteInput"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item
                            ripple
                            @mousedown.prevent
                            v-if="optionRow.id == 'company'"
                            @click="formValues['company'] = popularCompanies"
                          >
                            <v-list-item-action
                              ><v-icon color="primary">mdi-factory</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>
                                Select Alcon, B&amp;L, Cooper, and J&J
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider
                            class="mt-2"
                            v-if="optionRow.id == 'company'"
                          ></v-divider>
                        </template>
                        <template #selection="{ item }">
                          <v-chip
                            color="#f7dea5"
                            class="ma-1"
                            small
                            close
                            close-icon="mdi-close"
                            @click:close="
                              removeValueOption(optionRow.id, item.value)
                            "
                            >{{ item.label | truncate(20) }}</v-chip
                          >
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        v-else
                        v-model="formValues[optionRow.id]"
                        :items="optionRow.options"
                        item-value="value"
                        item-text="label"
                        dense
                        outlined
                        hide-details
                        auto-select-first
                        class="whiteInput"
                        menu-props="auto"
                        :multiple="optionRow.multiple"
                        :chips="optionRow.multiple"
                        :small-chips="optionRow.multiple"
                        :deletable-chips="optionRow.multiple"
                      >
                        <template #selection="{ item }">
                          <v-chip
                            color="#f7dea5"
                            class="ma-1"
                            small
                            close
                            close-icon="mdi-close"
                            @click:close="
                              removeValueOption(optionRow.id, item.value)
                            "
                            >{{ item.label | truncate(20) }}</v-chip
                          >
                        </template>
                      </v-autocomplete>
                    </div>

                    <v-btn-toggle
                      v-if="optionRow.options && optionRow.options.length <= 3"
                      v-model="formValues[optionRow.id]"
                      rounded
                      :multiple="optionRow.multiple"
                      active-class="orangeActive"
                      class="toggleBtns mt-1"
                    >
                      <v-btn
                        v-for="(option, i) in optionRow.options"
                        :key="'btn' + i"
                        small
                        :value="option.value"
                        v-html="option.label"
                      >
                      </v-btn>
                    </v-btn-toggle>
                    <div v-if="optionRow.suffix" class="suffix mx-2">
                      {{ optionRow.suffix }}
                    </div>
                  </div>
                </div>
              </v-card>
            </div>

            <v-fade-transition>
              <v-alert
                v-if="typeCount > 2"
                icon="mdi-unicorn-variant"
                color="purple lighten-5"
                class="ma-4"
                prominent
                shaped
              >
                Sorry, cosmetic toric bifocals are only available in fairy
                tales. You will need to remove the bifocal or the cosmetic
                options before proceeding..
              </v-alert>
              <v-alert
                v-else-if="typeMismatch.length"
                icon="mdi-alert"
                color="red lighten-5"
                class="ma-4"
              >
                <div v-html="typeMismatchMessage.message"></div>
                <v-btn
                  small
                  text
                  color="primary"
                  @click="type_tag = typeMismatchMessage.newType"
                >
                  {{ typeMismatchMessage.btn }}</v-btn
                >
              </v-alert>
            </v-fade-transition>

            <div class="px-2 d-flex flex-row my-6">
              <!-- <v-spacer class="d-none d-sm-flex"></v-spacer> -->
              <v-btn
                outlined
                red
                small
                color="red"
                @click="clearAll()"
                v-if="returnValueCount"
                class="mr-2"
                >Clear All</v-btn
              >
              <v-btn
                depressed
                small
                color="primary"
                outlined
                :disabled="!canSearch"
                :loading="searchLoading"
                @click="doSearch()"
                >Do Search</v-btn
              >
            </div>
            <v-alert
              text
              color="info"
              icon="mdi-information-outline"
              :border="'left'"
            >
              <h3 class="text-h6">How To Use Advanced Searches</h3>
              To create a query:
              <ul>
                <li>Choose the fields relevant to your search</li>
                <li>
                  Provide a value for each search field (not all search fields
                  require a value)
                </li>
                <li>Hit the "Do Search" button</li>
              </ul>
              Some advice:
              <ul>
                <li>
                  Don't add any more search fields than you need. Less is more.
                  The more restrictions you add, the more lenses that will be
                  filtered out
                </li>
                <li>
                  Avoid conflicting search fields. For example, don't search for
                  lenses in a polymer that has a water content of 60% AND lenses
                  with a water content less than 50%. You won't find any!
                </li>
              </ul>
            </v-alert>
          </v-col>
          <v-col class="d-none d-md-block" md="4">
            <cl-adv-search-fields
              :wantedItems="wantedItems"
              :formOptions="formOptions"
              @wantedItems="wantedItems = $event"
              :solo="true"
            ></cl-adv-search-fields>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- {{ searchResults }} -->
    <v-fade-transition>
      <div v-if="showResults && searchResults" v-show="!loading">
        <soft-result-display :lensObj="searchResults" :advancedSearch="true">
          <template v-slot:headerTitle>
            <div class="title">Advanced Search Results</div>
          </template>
          <template v-slot:headerContent>
            <div
              class="d-flex flex-row flex-wrap align-center"
              @click="showResults = false"
            >
              <div class="my-4 pointer mr-6">
                <div
                  v-for="(row, i) in summary"
                  :key="'summary' + i"
                  class="d-flex flex-row align-start pl-4"
                  style="font-size: 10pt; min-width: 350px"
                >
                  <!-- <v-btn icon small class="mr-2" @click="removeById(row.id)"
          ><v-icon color="red" small>mdi-minus-circle-outline</v-icon></v-btn
        > -->
                  <div style="width: 40px" class="pt-1">
                    <!-- {{ typeReplacePath + row.image }} -->
                    <v-icon v-if="row.icon" small color="primary"
                      >mdi-{{ row.icon }}</v-icon
                    >
                    <v-img
                      v-else-if="row.image"
                      :src="row.image"
                      width="16"
                      class="mr-2 pt-1"
                      position="center center"
                      contain
                    ></v-img>
                    <!-- {{ iconSrc + row.image }} -->
                  </div>
                  <div v-html="row.label" class="mt-1"></div>
                </div>
              </div>
              <v-btn small depressed outlined color="primary">
                <v-icon small color="primary" class="mr-2">mdi-pencil</v-icon>
                Edit Advanced Search Options</v-btn
              >
            </div>
          </template></soft-result-display
        >
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
import FiltersMixin from "@/assets/js/cls/FiltersMixin"; // only using a few methods

import TypeSelect from "@/components/clStuff/TypeSelect";
import ReplaceSelect from "@/components/clStuff/ReplaceSelect";
import FilterDictionary from "@/assets/js/cls/FilterDictionary";
import ClAdvSearchFields from "@/components/clStuff/ClAdvSearchFields.vue";

// import SoftCompanyPicker from "@/components/clStuff/SoftCompanyPicker";
// import ThreeWaySwitch from "@/components/universalStuff/ThreeWaySwitch.vue";

export default {
  components: {
    TypeSelect,
    ReplaceSelect,
    SoftResultDisplay: () => import("@/components/clStuff/SoftResultDisplay"),
    ClAdvSearchFields,
  },
  mixins: [FiltersMixin],
  name: "ClAdvancedSearch",
  props: {},
  data: function () {
    return {
      loading: false,
      iconSrc: "https://www.eyedock.com/images/menu_icons/",
      typeIconPath: "/images/icons/lensTypes/",
      replaceIconPath: "/images/icons/replace/",
      popularCompanies: ["1", "2", "4", "8"],
      showCompanyDialog: false,
      searchItemPicker: false,
      optionIdToAdd: null,
      wantedItems: [],
      formOptions: [],
      formValues: {},
      filters: {},
      type_tag: null,
      replace: null,
      replaceImage: null,
      typeImage: null,
      searchLoading: false,
      searchResults: null,
      showResults: false,
      // snackbar: false,
      // filters: {},
      meta: null, // indexesForIds = the formOptions index for each id ('ct','sphere_power')
    };
  },
  methods: {
    clearAll() {
      let doIt = confirm(
        "Are you sure you want to completely clear this form and start over?"
      );
      if (doIt) {
        this.wantedItems = [];
        this.type_tag = null;
        this.replace = null;
        this.formValues.type_tag = null;
        this.formValues.replace = null;
      }
    },
    removeById(id) {
      if (id == "replace") this.formValues.replace = "ANY";
      if (id == "type_tag") this.formValues.type_tag = "ANY";
      let index = this.wantedItems.indexOf(id);
      if (index != -1) this.wantedItems.splice(index, 1);
    },

    removeValueOption(key, val) {
      let index = this.formValues[key].indexOf(val);
      if (index != -1) this.formValues[key].splice(index, 1);
    },

    optionObjForId(id) {
      let indexesForIds = this.meta?.indexesForIds;
      return this.optionsRows?.(indexesForIds[id]);
    },

    callOptionsAPI() {
      // console.log("callin' options");
      this.loading = true;
      ApiServices.genericApiCall("/lens/advancedSearchOptions")
        .then((response) => {
          this.formOptions = response.data.searchOptions;
          this.meta = response.data.meta;
          this.createFormObject();
          // this.populateFromHash();
        })
        .catch((e) => {
          console.log("error loading advanced search form data from api", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // populate the formValues object with the formOptions keys {sphere:null, uv:null,...}
    createFormObject() {
      let formValues = {
        type_tag: this.hashValForKey("type_tag"),
        replace: this.hashValForKey("replace"),
      };
      let parametersInHash = 0;
      this.formOptions.forEach((row) => {
        // that.returnValues[row.id] = null;
        let val = row.input == "bool" ? 1 : null;
        if (row.input == "yes") val = 1;
        if (row.default) val = row.default;
        if (row.id == "company") val = this.popularCompanies;
        if (row.id == "sph") val = 0;

        // if a val was set in the url
        let hashVal = this.hashValForKey(row.id);
        // console.log(row.id, hashVal);
        let sign = 1; // make the "moreless" sign positive by default
        if (hashVal) {
          parametersInHash++;
          val = hashVal;
          if (row.multiple) val = val.split(",");
          if (row.isNumber || row.input == "bool") val = Number(val);
          if (row.input == "yes") val = 1;
          if (row.operator && row.operator == "moreless") {
            if (val < 1) sign = -1;
            val = Math.abs(val);
          }

          this.wantedItems.push(row.id);
        }
        //else if (row.default) val = row.default
        formValues[row.id] = val;
        if (row.operator && row.operator == "moreless") {
          formValues["moreless_" + row.id] = sign;
        }
      });
      this.formValues = formValues;
      if (formValues.polymer) this.checkForPolymerName();

      if (this.hashValForKey("type_tag")) parametersInHash++;
      if (this.hashValForKey("replace")) parametersInHash++;

      if (parametersInHash) this.doSearch();
    },
    diopterValue(val) {
      let rtn = "";
      val = Number(val);
      if (val > 0) rtn = "+";
      rtn += val.toFixed(2);
      return rtn;
    },
    companyListFromIds(ids) {
      let companiesById = this.companiesById;
      if (!companiesById) return null;
      let arr = [];
      ids.forEach((id) => {
        arr.push(companiesById[id]);
      });
      return "<ul><li>" + arr.join("</li><li>") + "</li></ul>";
    },
    polymerListFromIds(ids) {
      let polymersById = this.polymersById;
      if (!polymersById) return null;
      let arr = [];
      ids.forEach((id) => {
        arr.push(polymersById[id]);
      });
      return "<ul><li>" + arr.join("</li><li>") + "</li></ul>";
    },

    doSearch() {
      this.searchLoading = true;
      let paramString = this.objectToParamString(this.returnValues);
      paramString += "&byId=1"; // (the view by cards needs an object with lens Ids as keys)
      ApiServices.lensSearchAPI(paramString)
        .then((response) => {
          this.searchResults = response.data;
          //this.companiesLoaded = this.selectedCompanyIds;
          this.$emit("isPowerSearch", false);
          this.showResults = true;
          // todo - show message if no results
        })
        .catch((e) => {
          console.log(e); // todo - display it
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },
    checkForPolymerName() {
      let polymers = this.formValues.polymer;
      // console.log("checking for polymer names");
      let rtn = [];
      if (!Array.isArray(polymers)) polymers = [polymers];
      polymers.forEach((polymer) => {
        if (polymer && isNaN(polymer)) {
          // console.log(polymer + " us not a number");
          const name = decodeURIComponent(polymer);
          let ids = this.findPolymersWithNameLike(name);
          if (ids) rtn = [...rtn, ...ids];
        }
      });
      if (rtn.length) this.formValues.polymer = rtn;
    },
    findPolymersWithNameLike(name) {
      let polymersById = this.polymersById;
      if (!polymersById || !name) return null;
      name = name.toLowerCase().replace("+", " ");
      console.log(name);

      let rtn = [];
      Object.keys(polymersById).forEach((id) => {
        {
          let label = polymersById[id].toLowerCase();
          if (label.includes(name)) rtn.push(id);
        }
      });
      return rtn;
    },
  },
  computed: {
    optionRows: function () {
      // console.log(this.wantedItems);
      let rtn = [];
      let indexesForIds = this.meta?.indexesForIds;
      let formOptions = this.formOptions;
      if (!indexesForIds || !formOptions) return null;
      this.wantedItems.forEach((id) => {
        let index = indexesForIds[id];
        rtn.push(formOptions[index]);
      });
      return rtn;
    },
    // filteredLensesIds: function () {
    //   if (!this.searchResults) return null;
    //   return this.searchResults.map(function (obj) {
    //     return obj.id;
    //   });
    // },
    typesFromSelect: function () {
      let type_tag = this.type_tag;
      if (!type_tag) return null;
      let typeArr = type_tag.split("_");
      return typeArr.map(function (x) {
        return x.toUpperCase();
      });
    },
    typesFromOptions: function () {
      let types = []; //{ cosmetic: false, toric: false, bifocal: false };
      let wantedItems = this.wantedItems;
      let formValues = this.formValues;
      this.formOptions.forEach((row) => {
        if (wantedItems.includes(row.id)) {
          let val = formValues[row.id];
          if (val !== null) {
            ["COSMETIC", "BIFOCAL", "TORIC"].forEach((t) => {
              if (row.onlyType == t.toLowerCase() && !types.includes(t))
                types.push(t); //types.cosmetic = true;
            });
          }
        }
      });
      return types;
    },
    consolidatedType: function () {
      let formTypes = this.typesFromOptions;
      let selectType = this.typesFromSelect;
      if (!formTypes || formTypes.length < 1) return selectType?.join("_");
      let rtn = [];
      if (formTypes.includes("COSMETIC")) rtn.push("COSMETIC");
      if (formTypes.includes("BIFOCAL")) rtn.push("BIFOCAL");
      if (formTypes.includes("TORIC")) rtn.push("TORIC");
      if (!formTypes.includes("TORIC")) rtn.push("SPHERE");
      return rtn.join("_");
    },
    typeCount: function () {
      return this.typesFromOptions.length;
      // let count = 0;
      // Object.values(this.typesFromOptions).forEach((val) => {
      //   if (val && val != "0") count++;
      // });
      // return count;
    },
    typeMismatch: function () {
      let crnt = this.formValues?.type_tag;
      // console.log(crnt);
      if (!crnt || crnt == "ALL") return [];
      let tfo = this.typesFromOptions;
      let rtn = [];
      tfo.forEach((type) => {
        if (!crnt.includes(type.toUpperCase())) rtn.push(type);
      });

      return rtn;
    },
    typeMismatchMessage: function () {
      let message = "";
      let btn = "";
      let typeMismatch = this.typeMismatch;
      let ct = this.consolidatedType;
      // console.log(ct);
      if (typeMismatch.length) {
        message = `Your selections include criteria related to
        <i>${typeMismatch
          .join("</i> and <i>")
          .toLowerCase()
          .replace("bifocal", "multifocal")}</i>
        lenses, which conflicts with the lens type you've chosen (<i>${this.formValues.type_tag
          .toLowerCase()
          .replace("_", " ")
          .replace("bifocal", "multifocal")}</i>).`;
      }
      if (ct)
        btn = `Consider changing the type to "${ct
          .toLowerCase()
          .replace("_", " ")
          .replace("bifocal", "multifocal")}"`;

      return {
        message: message,
        btn: btn,
        newType: ct,
      };
    },

    returnValues: function () {
      let rtn = {};
      let wantedItems = this.wantedItems;
      let formValues = this.formValues;
      // let types = { cosmetic: false, toric: false, bifocal: false };

      // console.log("hi");
      if (formValues.replace && formValues.replace != "ALL")
        rtn.replace = formValues.replace;
      if (formValues.type_tag && formValues.type_tag != "ALL")
        rtn.type_tag = formValues.type_tag;
      this.formOptions.forEach((row) => {
        if (wantedItems.includes(row.id)) {
          let val = formValues[row.id];
          if (val !== null) {
            if (row.operator) {
              if (row.operator == "moreless") {
                let sign = formValues["moreless_" + row.id]; // == 1 ? 1 : -1;
                val *= sign;
                // console.log("moreless");
              }
            }
            // if (row.onlyType == "cosmetic") types.cosmetic = true;
            // if (row.onlyType == "bifocal") types.bifocal = true;
            // if (row.onlyType == "toric") types.toric = true;
            rtn[row.id] = val;
          }
        }
      });

      // this.checkForTypeChange(types);

      return rtn;
    },
    returnValueCount: function () {
      return Object.keys(this.returnValues).length;
    },
    canSearch: function () {
      return (
        this.typeMismatch.length == 0 &&
        this.typeCount < 3 &&
        this.returnValueCount > 0
      );
    },
    // a text summary of the form data
    // todo - do I really need to be iterating over these arrays again?
    summary: function () {
      let rtn = [];
      let returnValues = this.returnValues;
      let wantedIds = Object.keys(returnValues);
      let formOptionsById = this.formOptionsById;
      formOptionsById.replace = {
        id: "replace",
        name: "Replacement",
      };
      formOptionsById.type_tag = {
        id: "type_tag",
        name: "Lens type",
      };
      let that = this;

      wantedIds.forEach((id) => {
        const formData = formOptionsById[id];
        if (formData) {
          let o = { id: id };
          let name = formData.name;
          let value = returnValues[id];
          if (id == "type_tag") {
            let tObj = FilterDictionary.filterOptions.type[value];
            if (tObj) {
              o.image = that.typeIconPath + tObj.image + "_icon_active.svg";
              value = tObj.label;
            }

            // o.image =
            //   that.typeIconPath + value.toLowerCase() + "_icon_active.svg";
            // value = FilterDictionary.filterOptions.type[value]?.label;
          }
          if (id == "replace") {
            let rObj = FilterDictionary.filterOptions.replace[value];
            if (rObj) {
              o.image = that.replaceIconPath + rObj.image + "_active.svg";
              value = rObj.label;
            }
          }
          if (id == "company") value = that.companyListFromIds(value);
          if (id == "polymer") value = that.polymerListFromIds(value);
          // console.log(name, value);
          let summary = formData.summary;
          if (!summary) summary = `<b>${name}</b> is <i>[value]</i>`;
          let label = summary;
          let moreless = "";
          if (formData.operator == "moreless") {
            moreless = value < 0 ? "or less" : "or more";
            value = Math.abs(value);
          }
          if (formData.unit == "diopters") value = this.diopterValue(value);
          label = label.replace("[moreless]", moreless);
          label = label.replace("[value]", value);
          label = label.replace("[list]", value);
          label = label.replace("[bool]", value > 0 ? "Is" : "Is NOT");

          if (formData.icon) o.icon = formData.icon;
          if (formData.image) o.image = that.iconSrc + formData.image;

          // if (id == "replace") o.image = replaceImage;
          // let label = `summary`;
          // if (formData.select) o.label = `${name} is ${val}`;
          o.label = label;
          rtn.push(o);
        }
      });
      return rtn;
    },
    formOptionsById: function () {
      let rtn = {};
      this.formOptions.forEach((row) => {
        rtn[row.id] = row;
      });
      return rtn;
    },
    polymersById: function () {
      let options = this.formOptionsById?.polymer?.options;
      if (!options) return null;
      let rtn = {};
      options.forEach((row) => {
        rtn[row.value] = row.label;
      });
      return rtn;
    },
    // could probably use existing mixin for this..
    companiesById: function () {
      let options = this.formOptionsById?.company?.options;
      if (!options) return null;
      let rtn = {};
      options.forEach((row) => {
        rtn[row.value] = row.label;
      });
      return rtn;
    },
    imageForType: function () {
      // console.log(this.type_tag);
      return FilterDictionary.imageForType(this.type_tag);
    },
  },
  watch: {
    returnValues: {
      handler: function (val) {
        let hash = "#" + new URLSearchParams(val).toString();
        if (history.pushState) {
          history.pushState(null, null, hash);
        } else {
          location.hash = hash;
        }
      },
      deep: true,
    },
  },
  mounted() {
    // this.callPolymerAPI();
    let type_tag = this.hashValForKey("type_tag");
    let replace = this.hashValForKey("replace");
    if (type_tag) this.type_tag = type_tag;
    if (replace) this.replace = replace;
    this.callOptionsAPI();
  },
  metaInfo() {
    return {
      title: "EyeDock/CLs | Advanced Search",
    };
  },
};
</script>

<style scoped>
.paramCard {
  /* background-color: #eff8ff; */
  border: 1px solid #b8bcc0;
  background-image: linear-gradient(166deg, #e9f5ff, #f9fdff, #f1f8ff);
}

.suffix {
  font-size: 9pt;
  white-space: nowrap;
  color: #404449;
}

/* .theme--light.v-btn--active:hover::before,
.theme--light.v-btn--active::before {
  opacity: 0 !important;
} */
</style>
